import { Button, FormControl, Select, MenuItem, Typography, SelectChangeEvent, Box } from '@mui/material'
import React, { useState, useEffect } from 'react'
import { getBrandProjects } from '../../../api/endpoints'
import axiosInstant from '../../../api'


export const ProjectSelect = ({ ...props }) => {
  const projectId = props.projectId
  //const [projectId, setProjectId] = useState('')
  const [projects, setProjects] = useState([])
  //const { isLoading, embeds } = useGetProducts()

  const handleSubmit = async () => {
    let response;
    //let payload = { embedId: embedId, fileId: props.videoId }
    //response = await axiosInstant.post( addVideoToEmbed(), payload )
    props.onClose()
  }

  const handleSelectProject = (e:any) => {
    //setProductId(parseInt(event.target.value, 10))
    props.setProjectId(e.target.value)
  }

  // Get list for the add embed dropdown
  const fetchProjects = async () => {
    let response;
    response = await axiosInstant.get(getBrandProjects(props.brandId))
    const { data } = response
    if (data.rows.length > 0) {
      setProjects(data.rows)
    }
  }

  useEffect(() => {
    fetchProjects()
  }, [])

  return (
    <Box style={{ marginLeft: '20px' }}>
      <FormControl fullWidth>
        <Select
          id="demo-simple-select"
          onChange={handleSelectProject}
          size="small"
          displayEmpty
          value={projectId || ''}
        >
          <MenuItem key={''} value={''} selected={true}>
            <Typography sx={{ opacity: 0.5 }}>Select Distribution</Typography>
          </MenuItem>
          { projects.map((project:any, i) => (
            <MenuItem key={project.id} value={project.id}>{project.title}</MenuItem>
          ) ) }
        </Select>
      </FormControl>
      {/* <Button onClick={() => {handleSubmit()}} style={{marginTop:'20px'}} size="large" type="submit" variant="contained" disableElevation>
        Submit
      </Button> */}
    </Box>
  )

}